import React, { useState, useEffect } from 'react';
import { getIn18Text } from 'api';
import { Modal } from 'antd';
import { apiHolder, apis, apiHolder as api } from 'api';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import ItemCard from '../ItemCard';
import './index.scss';
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const pageSize = 20;
const StatusModal = ({ visible, onClose, involvedRecords, content, count }) => {
    const [contactsMap, setContactsMap] = useState({});
    const [contentCode, setContentCode] = useState('default');
    const [totalList, setTotalList] = useState(involvedRecords);
    const getContact = async (records) => {
        const emailList = records.map(item => {
            return item.acc_email;
        });
        try {
            const res = await contactApi.doGetContactByEmail({ emails: emailList });
            setContactsMap(res);
            setContentCode('SUCCESS');
        }
        catch (e) {
            setContentCode('Error');
        }
    };
    const onScrollCapture = (e) => {
        e.persist();
        if (count <= totalList.length)
            return;
        const container = document.querySelector('.thumb-up-container');
        if (container) {
            if (container.scrollHeight - container.scrollTop - container.clientHeight < 300) {
                getCurrentList({});
            }
        }
    };
    const getCurrentList = ({ init }) => {
        let page = 0;
        if (!init)
            page = Math.floor(totalList.length / pageSize) + 1;
        mailApi
            .getThumbUpInfo(content.id, content.entry.tid || '', page)
            .then(data => {
            if (data.involvedRecords && data.involvedRecords.length > 0) {
                const mergeList = [...totalList, ...data.involvedRecords];
                setTotalList(mergeList);
            }
        })
            .catch(err => {
            console.error('getThumbUpInfo error', err);
        });
    };
    const renderItem = (record) => {
        var _a, _b, _c;
        let contact = contactsMap[record.acc_email] || [];
        if (contact.length === 0) {
            const newContact = mailApi.buildRawContactItem({
                item: record.acc_email,
                email: record.acc_email,
                type: 'to',
                name: record.nick_name,
            });
            contact.push(newContact.contact);
        }
        else {
            let enterpriseContact = contact.filter(item => {
                var _a;
                return ((_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.type) === 'enterprise';
            });
            if (enterpriseContact.length >= 1) {
                contact = enterpriseContact;
            }
        }
        const model = contact[0];
        return (React.createElement("div", { className: "thumb-item", key: record.acc_id },
            React.createElement(ItemCard, { contact: model, type: "avatar", trigger: "click", domName: "body", placement: "left" },
                React.createElement("div", { style: {
                        marginRight: '12px',
                        marginLeft: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(AvatarTag, { size: 32, user: {
                            name: (_a = model === null || model === void 0 ? void 0 : model.contact) === null || _a === void 0 ? void 0 : _a.contactName,
                            avatar: (_b = model === null || model === void 0 ? void 0 : model.contact) === null || _b === void 0 ? void 0 : _b.avatar,
                            color: (_c = model === null || model === void 0 ? void 0 : model.contact) === null || _c === void 0 ? void 0 : _c.color,
                        } }))),
            React.createElement("div", { className: "thumb-item-div" },
                React.createElement("span", { className: "thumb-item-name" },
                    record.nick_name,
                    " "),
                React.createElement("span", { className: "thumb-item-email" }, contactApi.doGetModelDisplayEmail(model)))));
    };
    useEffect(() => {
        if (!visible)
            return;
        getContact(involvedRecords);
    }, [visible]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { footer: null, visible: visible, width: 480, title: getIn18Text('DIANZANXIANGQING'), wrapClassName: "thumb-up-modal", onCancel: onClose },
            React.createElement("div", { className: "thumb-up-container", style: { height: '100%', overflowY: 'scroll' }, onScrollCapture: onScrollCapture },
                React.createElement("div", null, contentCode === 'SUCCESS' &&
                    (totalList === null || totalList === void 0 ? void 0 : totalList.length) > 0 &&
                    totalList.map(record => {
                        return renderItem(record);
                    }))))));
};
export default StatusModal;
